module.exports = __webpack_public_path__ + "img/privilege.83c9033f.png";